import { Button } from "components/button/Button";
import { FC } from "react";
import { i18nService } from "services";
import { CookieCategories } from "types";
import { useCheckCookieConsent } from "utils";

interface EmbedBlockerContainerProps {
  isSocialEmbed?: boolean;
}

export const EmbedBlockerContainer: FC<EmbedBlockerContainerProps> = ({
  isSocialEmbed,
  children,
}) => {
  const checkConsent = useCheckCookieConsent(CookieCategories.marketing);

  const consent = isSocialEmbed ? checkConsent : true;

  return consent ? (
    <>{children}</>
  ) : (
    <div className="cta is-centered">
      <div className="cta__content">
        <div className="cta__text text">
          {i18nService.copy["embedBlock.message"]}
        </div>
        <div className="cta__button">
          <Button
            text={i18nService.copy["embedBlock.cta"]}
            onClick={() => window?.Cookiebot?.show()}
          />
        </div>
      </div>
    </div>
  );
};
